import AvatarWithName from "@/components/AvatarWithName";
import { DEFAULT_IMAGE_CARD } from "@/constants/image";
import { DeviceContext } from "@/context/device.context";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";

import { useContext, useEffect, useState } from "react";
import dynamic from "next/dynamic";
const ModalAddReviewProjectDetailMobile = dynamic(
  import("@/modules/Mobile/ProjectDetailMobile/ModalAddReviewProjectDetail"),
  {
    ssr: false,
  }
);
const ModalAddReviewProjectDetail = dynamic(
  import("./ModalAddReviewProjectDetail"),
  {
    ssr: false,
  }
);

const BoxReview = () => {
  const { user } = useAuth();
  const [openModalReview, setOpenModalReview] = useState(false);
  const [isOpenSelectFile, setIsOpenSelectFile] = useState(false);

  const { project, refUpload } = useContext(ProjectContext);
  useEffect(() => {
    if (isOpenSelectFile) {
      refUpload?.current?.click();
    }
  }, [isOpenSelectFile, refUpload]);

  const { isMobile } = useContext(DeviceContext);

  return (
    <>
      <div className="bg-white rounded-xl border border-solid border-grey-200 p-4 flex items-center gap-3 my-4 w-full">
        <AvatarWithName
          imageProps={{ resizeOnFly: false }}
          src={
            user?.avatar ? user?.avatar : user?.name ? null : DEFAULT_IMAGE_CARD
          }
          name={user?.name ?? "Ẩn danh"}
          avatarOnly
          imageClass="!w-10 !h-10"
          textClass="!text-white font-medium select-none"
          className="shrink-0"
        />
        <div
          className="border border-solid border-grey-200 p-3 text-fs-14 text-grey-600 rounded-full w-full h-10 flex items-center md:cursor-pointer"
          onClick={() => setOpenModalReview(true)}>
          Bạn review gì đi ...
        </div>
        <i
          className="mrv mrv-image text-green-400 text-fs-32 cursor-pointer"
          onClick={() => {
            setOpenModalReview(true);
            setIsOpenSelectFile(true);
          }}></i>
      </div>
      {openModalReview ? (
        <>
          {isMobile ? (
            <ModalAddReviewProjectDetailMobile
              open={openModalReview}
              handleClose={() => {
                setOpenModalReview(false);
                setIsOpenSelectFile(false);
              }}
              project={project}
              reviewType={1}
            />
          ) : (
            <ModalAddReviewProjectDetail
              open={openModalReview}
              handleClose={() => {
                setOpenModalReview(false);
                setIsOpenSelectFile(false);
              }}
              project={project}
              reviewType={1}
            />
          )}
        </>
      ) : null}
    </>
  );
};

export default BoxReview;
